export default __webpack_public_path__ + "static/media/alien.cf6c8660.svg";